import { render } from "./NoLineBreaks.vue?vue&type=template&id=26ea9482"
const script = {}

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__